/**
 * @desc 根据批次号列表查询入库信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/getBatchStockAgeByBatchNoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
